module.exports = __webpack_public_path__ + "img/campus-content-bg.e49e40b1.png";